/**
 * Значок категории уведомления.
 *
 * Отдельный компонент, а не выбор иконки в теле строки: значок зависит
 * только от категории, и вычислять тип компонента при каждом рендере
 * строки означало бы пересоздавать его — со сбросом состояния и
 * предупреждением react-hooks/static-components.
 */

import { Bell } from "lucide-react";
import type { NotificationCategory } from "@taskflow/contracts";

import { CATEGORY_ICONS } from "./notificationText";

export function CategoryIcon({
  type,
  className,
}: {
  type: NotificationCategory;
  className?: string;
}) {
  const Icon = CATEGORY_ICONS[type] ?? Bell;
  return <Icon className={className} aria-hidden />;
}
